// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 797) return "static/chunks/797-fa91e3c53f7dd560.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"85":"38367f19","146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal"}[chunkId] || chunkId) + "." + {"85":"e1d3b31fdb0f9b06","146":"983a867c9094c2be","298":"3c17f9a45cf5b456","340":"0f0defce6728a2ee","367":"5040e60c38bf6319","432":"fe519466e301961f","695":"7781d3868a3e0785"}[chunkId] + ".js";
};